import { Login } from "./Login";
import { Route, Routes, Navigate } from "react-router-dom";
import { ResetPassword } from "./ResetPassword";

const UnauthenticatedApp = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
}

export default UnauthenticatedApp;